import React, { useState } from 'react';
import Button from '../Button';
import { useNavigate, useLocation } from 'react-router-dom';
import { SLOT_STYLES } from './slotStyles';
import { useAuth } from '../../hooks/useAuth';
import { FormattedMessage } from 'react-intl';
import { PinModal } from './PinModal';

export const HeaderContent: React.FC = () => {
  const { isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const [showPinModal, setShowPinModal] = useState(false);

  return (
    <div className="flex items-center justify-end gap-5">
      <div className="flex flex-wrap justify-end gap-1">
        {Object.entries(SLOT_STYLES).map(
          ([key, { color, label, textColor }]) => {
            if (key === 'userBooked' && !isAuthenticated) {
              return null;
            }
            return (
              <div
                key={key}
                className="flex items-center gap-2 rounded-full px-3 text-gray-900"
                style={{ background: color, color: textColor }}
              >
                {label}
              </div>
            );
          },
        )}
      </div>

      {isAuthenticated ? (
        <>
          <Button onClick={() => setShowPinModal(true)} className="leading-4">
            <FormattedMessage defaultMessage="Visa pinkod" />
          </Button>
          <Button onClick={logout} className="leading-4">
            <FormattedMessage defaultMessage="Logga ut" />
          </Button>
        </>
      ) : null}

      {location.pathname !== '/booking' && (
        <Button onClick={() => navigate('/booking')} className="leading-4">
          <FormattedMessage defaultMessage="Mina kommande bokningar" />
        </Button>
      )}

      {showPinModal && <PinModal onClose={() => setShowPinModal(false)} />}
    </div>
  );
};
